import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { LoadingService } from '../../_services/loading.service';
import { ShipstationService } from '../_shemistshopservices/shipstation.service';

@Component({
  selector: 'app-shipstation-orders',
  templateUrl: './shipstation-orders.component.html',
  styleUrls: ['./shipstation-orders.component.css']
})
export class ShipstationOrdersComponent implements OnInit {

  allOrders: any = [];
  displayedColumns: string[] = ['OrderNumber', 'OrderDate', 'qa_status', 'FirstName', 
    'ItemName', 'Quantity', 'Status'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;

  newOrders: any = [];
  newOrdersdataSource: MatTableDataSource<any>;

  qaReceived: any = [];
  qaReceiveddataSource: MatTableDataSource<any>;

  applyPostage: any = [];
  applyPostagedataSource: MatTableDataSource<any>;

  orderDispatched: any = [];
  orderDispatcheddataSource: MatTableDataSource<any>;

  constructor(
  private titleService: Title,
  private shipstationService: ShipstationService,
  private loading : LoadingService) { }


  ngOnInit() {
    this.titleService.setTitle('Order List');
    this.onLoadOrders();
  }

  onLoadOrders() {
    //console.log('ok');
    var result = this.shipstationService.get_shipstation_orders().subscribe(data=> {

      console.log(data);
      // this.newOrders = data['data'].filter(x=> x.order_status_id === 1);
      // this.newOrdersdataSource = new MatTableDataSource<any>(this.newOrders);

      // this.qaReceived = data['data'].filter(x=> x.order_status_id === 2);
      // this.qaReceiveddataSource = new MatTableDataSource<any>(this.qaReceived);

      // this.applyPostage = data['data'].filter(x=> x.order_status_id === 3);
      // this.applyPostagedataSource = new MatTableDataSource<any>(this.applyPostage);

      // this.orderDispatched = data['data'].filter(x=> x.order_status_id === 4);
      // this.orderDispatcheddataSource = new MatTableDataSource<any>(this.orderDispatched);

      this.allOrders = data['orders'];
      this.dataSource = new MatTableDataSource<any>(this.allOrders);
      this.dataSource.paginator = this.paginator;
      this.loading.spin$.next(false);
    });
  }

  onViewOrder(order_id){
    console.log('onViewOrder');
  }  
  
  applyFilter()
  {
    this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

}

